import { twMerge } from 'tailwind-merge';
import PlumValuesLoader from '../../../assets/plum-values-loader-downsized.gif';

const LoadingScreen = ({
  title,
  description,
  titleClassName,
  className,
}: {
  title?: string;
  description?: string;
  titleClassName?: string;
  className?: string;
}) => {
  return (
    <div
      role="alert"
      aria-busy="true"
      aria-description={title}
      className={twMerge(
        'min-h-screen flex flex-col justify-center items-center',
        className,
      )}
    >
      <img src={PlumValuesLoader} alt="values-loader" height={72} width={72} />
      <h1
        className={twMerge(
          'font-chromatica text-2xl font-bold mt-4 text-mobile-gray-600',
          titleClassName,
        )}
      >
        {title}
      </h1>
      <p className="text-sm text-mobile-gray-400 mt-2">{description}</p>
    </div>
  );
};

export default LoadingScreen;
